import React, { useEffect, useRef } from 'react';
import styled from 'libs/styled';
import usePrefersReducedMotion from '@fogia/core-web/hooks/usePrefersReducedMotion';

const SlotVideo = styled('video')`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export interface VideoSlotProps {
    src: string;
}

const VideoSlot = ({ src }: VideoSlotProps) => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const prefersReducedMotion = usePrefersReducedMotion();
    const shouldAutoplay = !prefersReducedMotion;

    useEffect(() => {
        const video = videoRef.current;
        if (!video) {
            return;
        }

        if (shouldAutoplay) {
            video.play().catch(() => {});
        } else {
            video.pause();
        }
    }, [shouldAutoplay]);

    return (
        <SlotVideo
            ref={videoRef}
            src={src.includes('#') ? src : `${src}#t=0.001`}
            muted
            autoPlay={shouldAutoplay}
            loop
            playsInline
            preload="metadata"
            aria-hidden="true"
            tabIndex={-1}
        />
    );
};

export default VideoSlot;
